import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { fetchOptions } from '../queries';
import FormInput from './FormInput';

const FetchValueFormInput = ({ name, query, props, refresh }) => {
    const [originalValue, setOriginalValue] = useState();
    const { getValues, setValue } = useFormContext();

    const fetchAndSetValue = async (setOriginal) => {
        const { endpoint, useLoopback, where, fields, labelKey } = query;
        const fetchedValue = await fetchOptions({ endpoint, useLoopback, where, fields });
        setValue(name, fetchedValue[labelKey]);
        if (setOriginal) {
            setOriginalValue(fetchedValue[labelKey]);
        }
    };

    useEffect(() => {
        const [value] = getValues([name]);
        if (!value) {
            fetchAndSetValue(true);
        } else {
            setOriginalValue(value);
        }
    }, []);

    useEffect(() => {
        if (originalValue) {
            setValue(name, originalValue);
        }
    }, [refresh]);

    return <FormInput name={name} props={props} />;
};

export default FetchValueFormInput;
